import styled, { css } from 'styled-components';

import { layout } from '../../../package.json';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  @media (max-width: ${layout.mobile}) {
    padding-bottom: 85px;
  }
`;

export const Header = styled.div`
  width: 70%;

  margin-top: 30px;

  @media (max-width: ${layout.mobile}) {
    width: 90%;
    margin-top: 15px;
  }
`;

export const Title = styled.div`
  span {
    color: #000000;
    font-size: 43px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: left;
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 25px;
    }
  }
`;

export const List = styled.div`
  width: 70%;
  height: 300px;

  margin-top: 10px;

  @media (max-width: ${layout.mobile}) {
    width: 90%;
    height: 150px;
    margin-top: 0px;
  }
`;

export const Item = styled.div`
  width: 100%;

  margin-top: 16px;

  background-color: #f7f7f7;
  padding: 16px;
  border-radius: 10px;

  :last-child {
    margin-bottom: 85px;
  }
`;

export const ItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

// export const ItemNumber = styled.div`
//   width: 181px;
//   height: 35px;

//   span {
//     color: #000000;
//     font-size: 32px;
//     font-weight: 600;
//     font-style: normal;
//     letter-spacing: normal;
//     line-height: normal;
//     text-align: left;
//   }

//   @media (max-width: ${layout.mobile}) {
//     span {
//       font-size: 16px;
//     }
//   }
// `;
export const ItemNumber = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  span {
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    text-align: left;
  }

  p {
    color: #000000;
    font-size: 14px;
    font-weight: 400;
    margin: 4px 0 0;
    text-align: left;
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 16px; /* Ajuste para telas menores */
    }
    p {
      font-size: 12px; /* Ajuste para telas menores */
    }
  }
`;

export const ItemStatusOrder = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;

  margin-right: 120px;
  width: 350px;

  @media (max-width: ${layout.mobile}) {
    margin-right: 0px;
  }
`;

export const ItemStatusDetail = styled.div`
  width: 80%;

  span {
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: 26px;
    text-align: left;
  }
  p {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    letter-spacing: normal;
    line-height: 26px;
    text-align: left;
  }

  @media (max-width: ${layout.mobile}) {
    span {
      font-size: 16px;
    }
    p {
      font-size: 14px;
    }
  }
`;

interface ItemIconeProps {
  type?:
    | 'pending'
    | 'pending_payment'
    | 'payment_approved'
    | 'processing'
    | 'available'
    | 'available_pickup'
    | 'completed'
    | 'sent'
    | 'in_transit'
    | 'canceled'
    | 'closed'
    | 'fraud';
}

export const ItemIcone = styled.div<ItemIconeProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    color: #000;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
    margin-right: 16px;
  }

  svg {
    width: 30px;
    height: 30px;
    border-radius: 30px;
    background-color: #3aae36;

    ${props =>
      props.type === 'payment_approved' &&
      css`
        background-color: #3aae36;
      `}

    ${props =>
      props.type === 'pending' &&
      css`
        background-color: #e4e658;
      `}

    padding: 2px;
  }
`;

export const ItemDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ItemDetail = styled.div`
  span {
    color: #000000;
    font-size: 18px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: 26px;
    text-align: left;
  }
  p {
    color: #000000;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    letter-spacing: normal;
    line-height: 26px;
    text-align: left;
  }

  @media (max-width: ${layout.mobile}) {
    span,
    p {
      font-size: 14px;
    }
  }
`;

export const ItemBtn = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ItemShow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 280px;
  height: 41px;
  border-radius: 50px;
  background-color: #ff6b00;

  margin-right: 200px;
  cursor: pointer;

  span {
    color: #ffffff;
    font-size: 15px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: center;
    text-transform: uppercase;
    margin-right: 6px;
  }

  @media (max-width: ${layout.mobile}) {
    margin-right: 0px;
    width: 160px;
    height: 30px;
    margin-top: 85px;
    position: absolute;
    right: 30px;

    span {
      font-size: 13px;
    }
  }
`;

export const ItemAgain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-top: 6px;
  cursor: pointer;

  width: 150px;

  width: 280px;
  height: 41px;
  border-radius: 50px;
  background-color: #3d733b;

  span {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: normal;
    line-height: normal;
    text-align: left;
    text-transform: uppercase;
    margin-right: 6px;
  }
`;
